import React from 'react';

import { IconButton } from '@atlaskit/button/new';
import DropdownMenu, { DropdownItem, DropdownItemGroup } from '@atlaskit/dropdown-menu';
import EditorMoreIcon from '@atlaskit/icon/glyph/more';

import { type ThumbnailAction } from '../../types';

type ActionsDropdownComponentProps = {
	actions: ThumbnailAction[];
};

export const ActionsDropdownComponent = ({ actions }: ActionsDropdownComponentProps) => {
	return (
		<DropdownMenu<HTMLButtonElement>
			trigger={({ triggerRef, ...props }) => (
				<IconButton
					{...props}
					onClick={(event) => {
						event.stopPropagation();
						event.preventDefault();
						if (props.onClick) {
							props.onClick(event);
						}
					}}
					appearance="subtle"
					icon={EditorMoreIcon}
					label="Actions"
					ref={triggerRef}
					spacing="compact"
				/>
			)}
			shouldRenderToParent
			spacing="compact"
		>
			{actions &&
				actions.map((actionItem: ThumbnailAction) => (
					<DropdownItemGroup>
						<DropdownItem
							onClick={(event) => {
								event.stopPropagation();
								event.preventDefault();
								actionItem.action();
							}}
						>
							{actionItem.name}
						</DropdownItem>
					</DropdownItemGroup>
				))}
		</DropdownMenu>
	);
};
